<ng-image-slider
	[images]="fundraiserMediaList"
	[imageSize]="{ width: '250', height: 150 }"
	[imagePopup]="false"
	(imageClick)="openCustomDialog($event, fundraiserMediaList)"
	[showArrow]="mediaLength > 2 ? true : false"
	#nav
></ng-image-slider>
